"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";

export default function CadastroPage() {

  const router = useRouter();

  const [name,setName] = useState("");
  const [email,setEmail] = useState("");
  const [phone,setPhone] = useState("");
  const [document,setDocument] = useState("");

  const [cep,setCep] = useState("");
  const [address,setAddress] = useState("");
  const [district,setDistrict] = useState("");
  const [city,setCity] = useState("");
  const [state,setState] = useState("");

  const [password,setPassword] = useState("");

  const [loading,setLoading] = useState(false);
  const [message,setMessage] = useState("");

  const [number,setNumber] = useState("");
  const [complement,setComplement] = useState("");

  function maskDocument(value:string){

    value = value.replace(/\D/g,"");

    if(value.length <= 11){

      value = value.replace(/(\d{3})(\d)/,"$1.$2");
      value = value.replace(/(\d{3})(\d)/,"$1.$2");
      value = value.replace(/(\d{3})(\d{1,2})$/,"$1-$2");

    }else{

      value = value.replace(/^(\d{2})(\d)/,"$1.$2");
      value = value.replace(/^(\d{2})\.(\d{3})(\d)/,"$1.$2.$3");
      value = value.replace(/\.(\d{3})(\d)/,".$1/$2");
      value = value.replace(/(\d{4})(\d)/,"$1-$2");

    }

    return value;

  }

  function maskPhone(value:string){

    value = value.replace(/\D/g,"");

    value = value.replace(/^(\d{2})(\d)/,"($1) $2");
    value = value.replace(/(\d)(\d{4})$/,"$1-$2");

    return value;

  }

  function validarCPF(cpf:string){

    cpf = cpf.replace(/\D/g,"");

    if(cpf.length !== 11) return false;

    if(/^(.)\1+$/.test(cpf)) return false;

    let soma = 0;

    for(let i=0;i<9;i++){
      soma += parseInt(cpf[i]) * (10-i);
    }

    let resto = 11 - (soma % 11);
    if(resto > 9) resto = 0;

    if(resto !== parseInt(cpf[9])) return false;

    soma = 0;

    for(let i=0;i<10;i++){
      soma += parseInt(cpf[i]) * (11-i);
    }

    resto = 11 - (soma % 11);
    if(resto > 9) resto = 0;

    return resto === parseInt(cpf[10]);

  }

  function validarCNPJ(cnpj:string){

    cnpj = cnpj.replace(/\D/g,"");

    if(cnpj.length !== 14) return false;

    if(/^(.)\1+$/.test(cnpj)) return false;

    let tamanho = cnpj.length - 2;
    let numeros = cnpj.substring(0,tamanho);
    let digitos = cnpj.substring(tamanho);

    let soma = 0;
    let pos = tamanho - 7;

    for(let i=tamanho;i>=1;i--){
      soma += parseInt(numeros[tamanho-i]) * pos--;
      if(pos < 2) pos = 9;
    }

    let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;

    if(resultado !== parseInt(digitos[0])) return false;

    tamanho += 1;
    numeros = cnpj.substring(0,tamanho);

    soma = 0;
    pos = tamanho - 7;

    for(let i=tamanho;i>=1;i--){
      soma += parseInt(numeros[tamanho-i]) * pos--;
      if(pos < 2) pos = 9;
    }

    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;

    return resultado === parseInt(digitos[1]);

  }

  async function buscarCEP(cepValue:string){

  const cepLimpo = cepValue.replace(/\D/g,"");

  if(cepLimpo.length !== 8){
    return;
  }

  try{

    const res = await fetch(
      `https://viacep.com.br/ws/${cepLimpo}/json/`
    );

    if(!res.ok){
      return;
    }

    const data = await res.json();

    if(data.erro){
      setMessage("CEP não encontrado");
      return;
    }

    setAddress(data.logradouro || "");
    setDistrict(data.bairro || "");
    setCity(data.localidade || "");
    setState(data.uf || "");

  }catch(err){

    console.log("Erro CEP:",err);

  }

}

  async function handleSubmit(e:any){

    e.preventDefault();

    setMessage("");

    const doc = document.replace(/\D/g,"");

    if(doc.length === 11){

      if(!validarCPF(doc)){
        setMessage("CPF inválido");
        return;
      }

    }else if(doc.length === 14){

      if(!validarCNPJ(doc)){
        setMessage("CNPJ inválido");
        return;
      }

    }else{

      setMessage("Documento inválido");
      return;

    }

    setLoading(true);

    try{

      const res = await fetch(
        "https://api.nexbid.pro/auth/register",
        {
          method:"POST",
          headers:{
            "Content-Type":"application/json"
          },
          body:JSON.stringify({
            name,
            email,
            phone,
            document,
            cep,
            address,
            district,
            city,
            state,
            password
          })
        }
      );

      const data = await res.json();

      if(!res.ok){
        throw new Error(data.error);
      }

      setMessage(
        "Cadastro enviado! Aguarde aprovação do administrador."
      );

      setTimeout(()=>{
        router.push("/login");
      },2000);

    }catch{

      setMessage("Erro ao cadastrar.");

    }

    setLoading(false);

  }

    function maskCEP(value:string){

    value = value.replace(/\D/g,"");

    value = value.replace(/^(\d{5})(\d)/,"$1-$2");

    return value;

    }

  return(

    <div style={{maxWidth:420,margin:"80px auto"}}>

      <h1>Cadastro === NexBid === </h1>

      {message && (
        <div style={{marginBottom:15,color:"#c00"}}>
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit}>

        <input
          placeholder="Nome completo"
          value={name}
          onChange={e=>setName(e.target.value)}
          required
          style={{width:"100%",marginBottom:10}}
        />

        <input
          placeholder="CPF ou CNPJ (somente números)"
          value={document}
          onChange={(e)=>setDocument(maskDocument(e.target.value))}
          required
          style={{width:"100%",marginBottom:10}}
        />

        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={e=>setEmail(e.target.value)}
          required
          style={{width:"100%",marginBottom:10}}
        />

        <input
          placeholder="Telefone"
          value={phone}
          onChange={(e)=>setPhone(maskPhone(e.target.value))}
          required
          style={{width:"100%",marginBottom:10}}
        />

        <input
            placeholder="CEP"
            value={cep}
            onChange={(e)=>{

                const value = maskCEP(e.target.value);

                setCep(value);

                if(value.replace(/\D/g,"").length === 8){
                buscarCEP(value);
                }

            }}
            required
            style={{width:"100%",marginBottom:10}}
            />

        <input
          placeholder="Endereço"
          value={address}
          onChange={e=>setAddress(e.target.value)}
          required
          style={{width:"100%",marginBottom:10}}
        />

        <input
            placeholder="Número"
            value={number}
            onChange={e=>setNumber(e.target.value)}
            required
            style={{width:"100%",marginBottom:10}}
            />

            <input
            placeholder="Complemento (apto, sala, bloco)"
            value={complement}
            onChange={e=>setComplement(e.target.value)}
            style={{width:"100%",marginBottom:10}}
            />

        <input
          placeholder="Bairro"
          value={district}
          onChange={e=>setDistrict(e.target.value)}
          required
          style={{width:"100%",marginBottom:10}}
        />

        <input
          placeholder="Cidade"
          value={city}
          onChange={e=>setCity(e.target.value)}
          required
          style={{width:"100%",marginBottom:10}}
        />

        <input
          placeholder="Estado"
          value={state}
          onChange={e=>setState(e.target.value)}
          required
          style={{width:"100%",marginBottom:10}}
        />

        <input
          type="password"
          placeholder="Senha"
          value={password}
          onChange={e=>setPassword(e.target.value)}
          required
          style={{width:"100%",marginBottom:10}}
        />

        <button disabled={loading} style={{width:"100%"}}>
          {loading ? "Cadastrando..." : "Cadastrar"}
        </button>

      </form>

    </div>

  );

}